import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enDashboard from "./locales/en/dashboard.json";
import roDashboard from "./locales/ro/dashboard.json";
import enCommon from "./locales/en/common.json";
import roCommon from "./locales/ro/common.json";
import enClient from "./locales/en/client.json";
import roClient from "./locales/ro/client.json";
import enTabsDrawer from "./locales/en/tabsDrawer.json";
import roTabsDrawer from "./locales/ro/tabsDrawer.json";
import enCatalogue from "./locales/en/catalogue.json";
import roCatalogue from "./locales/ro/catalogue.json";
import enProducts from "./locales/en/product.json";
import roProducts from "./locales/ro/product.json";
import enAuthentication from "./locales/en/authentication.json";
import roAuthentication from "./locales/ro/authentication.json";
import enSales from "./locales/en/sales.json";
import roSales from "./locales/ro/sales.json";
import enNotification from "./locales/en/notification.json";
import roNotification from "./locales/ro/notification.json";
import enReport from "./locales/en/reporting.json";
import roReport from "./locales/ro/reporting.json";
import enSubscription from "./locales/en/subscription.json";
import roSubscription from "./locales/ro/subscription.json";
import enWithdraw from "./locales/en/withdraw.json";
import roWithdraw from "./locales/ro/withdraw.json";
import enFaq from "./locales/en/faq.json";
import roFaq from "./locales/ro/faq.json";
import enBlog from "./locales/en/blog.json";
import roBlog from "./locales/ro/blog.json";
import enSetting from "./locales/en/setting.json";
import roSetting from "./locales/ro/setting.json";
import enAppointment from "./locales/en/appointment.json";
import roAppointment from "./locales/ro/appointment.json";
import enDonation from "./locales/en/donation.json";
import roDonation from "./locales/ro/donation.json";

const currentLanguage = localStorage.getItem("currentLang") || "ro";

i18n.use(initReactI18next).init({
    resources: {
        en: {
            common: enCommon,
            authentication: enAuthentication,
            dashboard: enDashboard,
            client: enClient,
            tabsDrawer: enTabsDrawer,
            catalogue: enCatalogue,
            products: enProducts,
            sales: enSales,
            notification: enNotification,
            report: enReport,
            subscription: enSubscription,
            withdraw: enWithdraw,
            faq: enFaq,
            blog: enBlog,
            setting: enSetting,
            appointment: enAppointment,
            donation: enDonation,
        },
        ro: {
            common: roCommon,
            authentication: roAuthentication,
            dashboard: roDashboard,
            client: roClient,
            tabsDrawer: roTabsDrawer,
            catalogue: roCatalogue,
            products: roProducts,
            sales: roSales,
            notification: roNotification,
            report: roReport,
            subscription: roSubscription,
            withdraw: roWithdraw,
            faq: roFaq,
            blog: roBlog,
            setting: roSetting,
            appointment: roAppointment,
            donation: roDonation,
        }
    },
    lng: currentLanguage,
    fallbackLng: "en",
    defaultNS: "common",
    interpolation: {
        escapeValue: false
    }
});

export default i18n;
